import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ToastProvider } from './contexts/ToastContext';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import Login from './components/Login';
import ForgotPassword from './components/ForgotPassword';
import ResetPassword from './components/ResetPassword';
import Dashboard from './pages/Dashboard';
import Users from './pages/Users';
import UserDetail from './pages/UserDetail';
import Certificates from './pages/Certificates';
import Reminders from './pages/Reminders';
import AuditLogs from './pages/AuditLogs';
import EnhancedRoleManagement from './components/EnhancedRoleManagement';
import Settings from './pages/Settings';
import Tags from './pages/Tags';
import Reports from './pages/Reports';
import EmailTemplates from './pages/EmailTemplates';
import SMSTemplates from './pages/SMSTemplates';
import SubAdminActivation from './pages/SubAdminActivation';
import SubAdminLogin from './pages/SubAdminLogin';
import './styles/brand.css';
import Landing from './pages/Landing';

// Note: Axios configuration is now handled in utils/api.js to avoid conflicts

function App() {
  return (
    <ToastProvider>
      <AuthProvider>
        <Router>
          <div className="min-h-screen">
            <Routes>
              {/* Public Routes */}
              <Route path="/" element={<Landing />} />

              <Route path="/login" element={<Login />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              
              {/* Sub Admin Public Routes */}
              <Route path="/sub-admin/activate" element={<SubAdminActivation />} />
              <Route path="/sub-admin/login" element={<SubAdminLogin />} />
              <Route path="/sub-admin/forgot-password" element={<ForgotPassword />} />
              <Route path="/sub-admin/reset-password" element={<ResetPassword />} />
              
              {/* Protected Routes */}
              <Route path="/*" element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }>
                {/* <Route index element={<Navigate to="/dashboard" replace />} /> */}
                <Route path="dashboard" element={<Dashboard />} />
                <Route path="users" element={<Users />} />
                <Route path="users/:userId" element={<UserDetail />} />
                <Route path="certificates" element={<Certificates />} />
                <Route path="reminders" element={<Reminders />} />
                <Route path="tags" element={<Tags />} />
                <Route path="reports" element={<Reports />} />
                <Route path="templates/email" element={<EmailTemplates />} />
                <Route path="templates/sms" element={<SMSTemplates />} />
                <Route path="audit-logs" element={
                  <ProtectedRoute requireSuperAdmin={true}>
                    <AuditLogs />
                  </ProtectedRoute>
                } />
                <Route path="role-management" element={
                  <ProtectedRoute requireSuperAdmin={true}>
                    <EnhancedRoleManagement />
                  </ProtectedRoute>
                } />
                <Route path="settings" element={
                  <ProtectedRoute requireSuperAdmin={true}>
                    <Settings />
                  </ProtectedRoute>
                } />
              </Route>
              
              {/* Catch all route */}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </div>
        </Router>
      </AuthProvider>
    </ToastProvider>
  );
}

export default App;
